import { formatDate, formatDateTime } from '@utils/date'
import { formatCurrency } from '@utils'
import { FaRegCalendar } from 'react-icons/fa'
import cn from 'clsx'

const CheckDetailsSummary = ({
    className,
    check,
    checkRevenue,
}) => {
    
    const isImported = check.status === 'imported'
    
    return (
        
        <div className={cn('CheckDetailsSummary', className)}>
            
            <div className="summary flex">
                <ul className="flex-1">
                    <li>
                        <b>Name:</b> &nbsp;{check.name}
                    </li>
                    <li>
                        <b>Owner Name:</b> &nbsp;{check.owner}
                    </li>
                    <li>
                        <b>Owner Number:</b> &nbsp;N/A
                    </li>
                </ul>
                <ul className="flex-1">
                    <li className="flex gap-1 items-center">
                        <b>Check detail</b>
                        <span className="badge badge-success mx-3">Live</span>
                        <span className="text-xs flex gap-1 items-center">
                            <FaRegCalendar />
                            {isImported && !check.fileExists ? ' Imported ' : ' Uploaded '}
                            {formatDateTime(
                                isImported && check.fileExists
                                    ? check.updatedAt
                                    : check.createdAt, 'MM/DD/YY, hh:mm a')}
                        </span>
                    </li>
                    <li>
                        <b>Operator:</b> &nbsp;{check.operator}
                    </li>
                    <li>
                        <b>Check Date:</b> &nbsp;{formatDate(check.checkDate, 'MMMM DD, YYYY')}
                    </li>
                    <li>
                        <b>Check Number:</b> &nbsp;{check.checkNumber}
                    </li>
                </ul>
            </div>
            
            <h4 className="mt-4 text-xl">Revenue</h4>
            
            <div className="revenue">
                <div>
                    <p>Owner Gross Revenue</p>
                    <h4>{formatCurrency(checkRevenue.gross || 0)}</h4>
                </div>
                <div>
                    <p>Owner Adjustments</p>
                    <h4>{formatCurrency(checkRevenue.adjustments || 0)}</h4>
                </div>
                <div>
                    <p>Owner Net Revenue</p>
                    <h4>{formatCurrency(checkRevenue.net || 0)}</h4>
                </div>
            </div>
        
        </div>
        
    )
    
}

export default CheckDetailsSummary
